export const SUPPORTED_MARKDOWN_STRING_LITERALS = {
    title: "BLOCK_QUALIFIED_TITLE:",
    description: "BLOCK_QUALIFIED_DESCRIPTION:",
    questionStart: "BLOCK_QUALIFIED_QUESTION_START:",
    answerStart: "BLOCK_QUALIFIED_ANSWER_START:"
}